/**
 * localeType说明:
 * pub: src/public使用，如页面信息、搜索、过滤等
 * nav: 主菜单
 * tab: Manager tab名
 * button:
 * 
 * common:
 */

const allLocales = {
	zh_CN: {
		name: '中文',
		pubMod: () => import(/* webpackChunkName: "chunks/public/locale/syncFusion" */'@syncfusion/ej2-base')
			.then(mod => import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./syncfusion/zh.json')
				.then(zh => mod.L10n.load(zh.default))
				.then(() => {
					const { loadCldr, setCulture } = mod
					setCulture('zh')
					const args = []
					args.push(import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./cldr-data/main/zh/ca-gregorian.json'))
					args.push(import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./cldr-data/main/zh/numbers.json'))
					args.push(import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./cldr-data/main/zh/timeZoneNames.json'))

					args.push(import(/* webpackChunkName: "chunks/public/locale/syncFusion" */'./cldr-data/supplemental/numberingSystems.json'))
					args.push(import(/* webpackChunkName: "chunks/public/locale/syncFusion" */'./cldr-data/supplemental/weekData.json'))

					return Promise.all(args).then(values => {
						loadCldr(...values.map(v => v.default))
					}).then(() => import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./zh_CN'))
					// loadCldr(gregorian, timeZoneNames, numberingSystems, numbers, weekData);
				})
			)
	},
	en: {
		name: 'En',
		pubMod: () => import(/* webpackChunkName: "chunks/public/locale/en" */'./en'),
	}
}

let appLocales = {
	// zh_CN: '中文'
}

// 设置当前使用语言
export const setLocale = locale => {
	const curr = Tyan.psnCfg.locale

	curr !== locale && (Tyan.setPsnCfg({ locale }), window.location.reload())
}

// 读取当前使用语言
export const getLocale = () => {
	// 读取locale, 如果不存在,则设置为'zh_CN'，并重新加载
	const locale = Tyan.psnCfg.locale || Object.keys(appLocales)[0]
	if (appLocales[locale])
		return locale
	setLocale(Object.keys(appLocales)[0])
	// setLocale('zh_CN')
	return undefined
}

// 设置可用语言及相应的翻译模块
export const setLocales = locales => {
	Object.keys(appLocales).forEach(o => delete appLocales[o])
	let loc
	for (let [key, mod] of Object.entries(locales)) {
		if (!(loc = allLocales[key])) throw `无效语言代码 ${key}`
		appLocales[key] = loc.name
		loc.mod = mod
	}
	!Object.keys(appLocales).length && (appLocales.zh_CN = '中文')
}

// 读取可用语言用于呈现及切换
export const getLocales = () => {
	return { ...appLocales }
}

// 装载当前语言处理模块
export const loadLocale = () => {
	// 检查当前locale
	const locale = getLocale()
	if (!locale) return Promise.resolve()

	// pub、 app data or fn
	let pub = undefined, app = undefined

	return allLocales[locale].pubMod()
		.then(pubMod => pub = pubMod.pub)
		.then(() => allLocales[locale].mod ? allLocales[locale].mod() : {})
		.then(appMod => app = appMod && appMod.default)
		.then(() => (pub || app) && genT(pub, app))
}

let cacheToSave = {}
let tmrSaveCache = undefined

const saveCache = () => {
	tmrSaveCache = null
	console.warn('miss locale', Tyan.getLocale(), { ...cacheToSave })
	// cacheToSave = {}
}

const trySaveCache = (v, type) => {
	// console.log('cache:', v, type)
	tmrSaveCache && (clearTimeout(tmrSaveCache), tmrSaveCache = null)
	cacheToSave[v] = cacheToSave[v] || {}
	cacheToSave[v][type] = true
	tmrSaveCache = setTimeout(saveCache, 3000)
}

const genT = (pub, app) => {
	const debug = app && typeof app !== 'function' && app.debug ? o => `T ${o}` : o => o

	let tData = Ext.merge({
		common: {
			text: {
				'&nbsp': '&nbsp',
				' ': ' '
			},
		}
	}, pub && typeof pub !== 'function' && pub || {}, app && typeof app !== 'function' && app || {})
	// 整理所有text下属性为函数
	Object.values(tData).forEach(type => {
		if (type.constructor === Boolean) return
		const text = type.text = type.text || {}
		Object.entries(text).forEach(([key, value]) => {
			typeof value !== 'function' && (text[key] = () => value)
		})
		type.regexp = Object.entries(type.regexp || {})
	})

	tData._cache = {}
	let temp = undefined

	const pubFn = (...args) => args[0] && tByData(...args) || pub(...args) || cache(...args)
	const appFn = (...args) => args[0] && tByData(...args) || app(...args) || cache(...args)
	const appFnPubFn = (...args) => args[0] && tByData(...args) || app(...args) || pub(...args) || cache(...args)
	const dataPubFn = (...args) => args[0] && tByData(...args) || pub(...args) || cache(...args)
	const dataAppFn = (...args) => args[0] && tByData(...args) || app(...args) || cache(...args)
	const tByDataCache = (...args) => args[0] && tByData(...args) || cache(...args)

	const cache = (v, type) => {
		// 未找到匹配，置于cache，返回v
		temp = tData._cache[v] = tData._cache[v] || {}
		temp[type] = true
		!tData.noCache && trySaveCache(v, type)

		return debug(v)
	}

	const tByData = (v, type, ...args) => {
		// 首先检查是否存在cache(即曾经处理过但没有任何匹配的数据)，如果存在相同localType数据则直接返回原值
		if (tData._cache[v] && tData._cache[v][type])
			return debug(v)

		// 优先根据type处理，然后在common中处理
		for (const locale of [tData[type], tData.common].filter(o => o)) {
			// 直接文本存在则直接返回
			if (locale.text && locale.text[v]) return locale.text[v](type, ...args)
			// 正则表达式处理
			let m
			for (let [exp, fn] of locale.regexp) {
				if (m = v.match(exp)) return fn(type, m)
			}
		}

		return undefined
	}

	const tFn = !pub
		? (app && typeof app === 'function' ? appFn : tByDataCache)
		: typeof pub === 'function'
			? (!app ? pubFn : typeof app === 'function' ? appFnPubFn : dataPubFn)
			: app && typeof app === 'function' ? dataAppFn : tByDataCache

	// Tyan.t = (...args) => {
	// 	if (args[0] && args[0].includes('博世汽车系统')) {
	// 		console.log('t:', args)
	// 	}
	// 	const ret = tFn(...args)
	// 	return ret
	// }

	Tyan.t = tFn
}
